(() => {
  function init() {
    const section = document.querySelector('#rz-inquiry');
    const picker = document.querySelector('#rz-inquiry-route');
    function localize(link) {
      if (!section || !picker || link.closest('#rz-inquiry') || link.dataset.rzLocalInquiry) return;
      let url; try { url = new URL(link.href, location.href); } catch { return; }
      if (url.origin !== location.origin || !(url.searchParams.get('view') === 'rz-request-evaluation' || url.pathname === '/request-evaluation')) return;
      link.dataset.rzLocalInquiry = url.search;
      link.href = '#rz-inquiry';
    }
    document.querySelectorAll('a[href]').forEach(localize);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('a[href]')) localize(node);
      node.querySelectorAll('a[href]').forEach(localize);
    }))).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('click', event => {
      const link = event.target.closest('a[data-rz-local-inquiry]');
      if (!link || !section || event.ctrlKey || event.metaKey || event.shiftKey) return;
      event.preventDefault();
      section.dispatchEvent(new CustomEvent('rz:inquiry-context', {detail:link.dataset.rzLocalInquiry}));
      section.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      document.querySelector('#rz-inquiry-title')?.focus({preventScroll:true});
      history.replaceState(null, '', '#rz-inquiry');
    });
    // A navigation shortcut, never a duplicate add-to-cart or bypass of variant selection.
    let buy = document.querySelector('.product__info button[name="add"]');
    if (buy) {
      const target = buy.closest('.product__info');
      if (target && !target.id) target.id = 'rz-buy-options';
      if (target) {
        const shortcut = document.createElement('a');
        shortcut.className = 'rz-buy-shortcut'; shortcut.href = '#' + target.id;
        shortcut.textContent = document.documentElement.lang.startsWith('es') ? 'Elige las opciones y compra' : 'Choose options and buy'; shortcut.hidden = true;
        document.body.appendChild(shortcut);
        let scheduled = false;
        const update = () => {
          scheduled = false;
          buy = [...target.querySelectorAll('button[name="add"]')].find(button=>button.getClientRects().length) || buy;
          const native = document.querySelector('.product-sticky-form__card');
          const nativeVisible = native && getComputedStyle(native).visibility === 'visible' && Number(getComputedStyle(native).opacity) > 0;
          const footer = document.querySelector('#rz-site-footer');
          const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight;
          shortcut.hidden = footerVisible || nativeVisible || !buy.getClientRects().length || buy.getBoundingClientRect().bottom >= 0;
        };
        const schedule = () => {if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
        addEventListener('scroll',schedule,{passive:true}); addEventListener('resize',schedule);
        new MutationObserver(schedule).observe(target,{childList:true,subtree:true});
        update();
        shortcut.addEventListener('click', () => { buy.focus({preventScroll:true}); });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
